import React from 'react';
import styles from './EmptyState.module.css';

export default function EmptyState({ icon, title = 'Nenhum resultado', description }) {
  return (
    <div className={styles.container}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <h3 className={styles.title}>{title}</h3>
      {description && <p className={styles.description}>{description}</p>}
    </div>
  );
}
